/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuppliersToRemove } from '../../models/suppliers-to-remove';
import { SupplierWithoutData } from '../../models/supplier-without-data';

export interface RemoveSuppliersApiV2MembersOrgSuppliersDelete$Params {
  org: string;
      body: SuppliersToRemove
}

export function removeSuppliersApiV2MembersOrgSuppliersDelete(http: HttpClient, rootUrl: string, params: RemoveSuppliersApiV2MembersOrgSuppliersDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupplierWithoutData>>> {
  const rb = new RequestBuilder(rootUrl, removeSuppliersApiV2MembersOrgSuppliersDelete.PATH, 'delete');
  if (params) {
    rb.path('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SupplierWithoutData>>;
    })
  );
}

removeSuppliersApiV2MembersOrgSuppliersDelete.PATH = '/api/v2/members/{org}/suppliers';
